import React, { cloneElement } from 'react';
import { v4 } from 'uuid';
import Classnames from 'classnames';
import { EshopsComponentsTitles, Typography, Action } from '@mshops-components-library/common';
import { Image } from 'frontend-image';
import { Button } from '@andes/button';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
var THEME_TITLE_FONT = 'legend';
var ESHOP = 'eshop';
var namespace = 'section-category';
var replaceExtension = function replaceExtension(url) {
  var regex = /(\.(?!svg|webp$)[a-zA-Z0-9]+)$/i;
  return url === null || url === void 0 ? void 0 : url.replace(regex, '.webp');
};
const CategoryGallery = /*#__PURE__*/function () {
  const CategoryGallery = function CategoryGallery(_ref) {
    var title = _ref.title,
      action = _ref.action,
      children = _ref.children,
      editable = _ref.editable,
      fakeChildren = _ref.fakeChildren,
      categories = _ref.categories,
      layoutTheme = _ref.layoutTheme,
      onAction = _ref.onAction,
      _ref$deviceType = _ref.deviceType,
      deviceType = _ref$deviceType === void 0 ? 'mobile' : _ref$deviceType,
      _ref$isSuper = _ref.isSuper,
      isSuper = _ref$isSuper === void 0 ? false : _ref$isSuper,
      _ref$isIOS = _ref.isIOS17,
      isIOS17 = _ref$isIOS === void 0 ? false : _ref$isIOS,
      eshopType = _ref.eshopType,
      textAlignment = _ref.text_alignment,
      elementsAlignment = _ref.elements_alignment,
      customStyles = _ref.custom_styles,
      shopModel = _ref.shopModel,
      trackingId = _ref.trackingId;
    var isMobile = deviceType === 'mobile';
    var sizeTitleTypography = isMobile ? 'small' : 'medium';
    var isMinCategories = (categories === null || categories === void 0 ? void 0 : categories.length) < 2;
    var sectionClasses = Classnames("".concat(namespace, " ").concat(namespace, "--").concat(deviceType, " ").concat(namespace, "--").concat(layoutTheme), _defineProperty({}, "".concat(namespace, "--ios17"), isIOS17));
    var columnClasses = Classnames("".concat(namespace, "__columns"), "".concat(namespace, "__columns__item"), _defineProperty(_defineProperty({}, "".concat(namespace, "__columns--").concat(categories.length, "item"), !isMinCategories), "".concat(namespace, "__columns--minItem"), isMinCategories));
    var titleClasses = Classnames("".concat(namespace, "__title"), _defineProperty({
      'font-primary-text': layoutTheme !== THEME_TITLE_FONT,
      'font-secondary-text': layoutTheme === THEME_TITLE_FONT
    }, "".concat(namespace, "__title--").concat(textAlignment), textAlignment));
    var eshopsTitleClasses = Classnames("".concat(namespace, "__title"), _defineProperty({}, "".concat(namespace, "__title--super"), isSuper));
    var titleAlignClasses = Classnames("".concat(namespace, "__title"), _defineProperty({}, "".concat(namespace, "__title--").concat(textAlignment), textAlignment));
    var handleClick = function handleClick(ev) {
      if (action && onAction) {
        ev.preventDefault();
        onAction({
          url: action.target,
          behavior: action.behavior
        });
      }
    };
    var setExtraPropsCategories = function setExtraPropsCategories(index) {
      var _categories$index, _categories$index2;
      var extraPropsCategories = {
        key: v4(),
        trackingId: trackingId,
        customStyles: customStyles,
        shopModel: shopModel,
        isMobile: isMobile,
        elementsAlignment: elementsAlignment
      };
      var newImageByDevice = (_categories$index = categories[index]) === null || _categories$index === void 0 || (_categories$index = _categories$index.images) === null || _categories$index === void 0 || (_categories$index = _categories$index[deviceType]) === null || _categories$index === void 0 ? void 0 : _categories$index.source;
      var isDefaultImage = newImageByDevice === ((_categories$index2 = categories[index]) === null || _categories$index2 === void 0 ? void 0 : _categories$index2.original_image);
      if (newImageByDevice) {
        extraPropsCategories.styles = {
          background_image: replaceExtension(newImageByDevice),
          is_default_image: isDefaultImage
        };
      }
      return extraPropsCategories;
    };
    var showTitles = function showTitles() {
      if (!(title !== null && title !== void 0 && title.text) || title !== null && title !== void 0 && title.hidden) {
        return null;
      }
      if (typeEshop(eshopType)) {
        return /*#__PURE__*/_createRawReactElement(EshopsComponentsTitles, {
          title: title === null || title === void 0 ? void 0 : title.text,
          subtitle: title === null || title === void 0 ? void 0 : title.subtitle,
          showTitle: !(title !== null && title !== void 0 && title.hidden),
          deviceType: deviceType,
          titleClassName: titleClasses,
          subtitleClassName: titleClasses
        });
      }
      if (layoutTheme === ESHOP) {
        return /*#__PURE__*/_createRawReactElement("div", {
          className: "".concat(namespace, "__title--layout")
        }, void 0, /*#__PURE__*/_createRawReactElement("span", {
          className: eshopsTitleClasses
        }, void 0, title.text), (action === null || action === void 0 ? void 0 : action.label) && /*#__PURE__*/_createRawReactElement("a", {
          className: "".concat(namespace, "__action--label"),
          href: action === null || action === void 0 ? void 0 : action.target,
          "aria-label": action === null || action === void 0 ? void 0 : action.label,
          onClick: handleClick
        }, void 0, action === null || action === void 0 ? void 0 : action.label));
      }
      return /*#__PURE__*/_createRawReactElement(Typography, {
        className: titleAlignClasses,
        type: "title",
        size: sizeTitleTypography,
        weight: "bold"
      }, void 0, title.text);
    };
    return /*#__PURE__*/_createRawReactElement("section", {
      className: sectionClasses
    }, void 0, /*#__PURE__*/_createRawReactElement("div", {
      className: "row container ".concat(namespace, "__container")
    }, void 0, showTitles(), /*#__PURE__*/_createRawReactElement("div", {
      className: columnClasses
    }, void 0, children === null || children === void 0 ? void 0 : children.map(function (item, index) {
      return /*#__PURE__*/cloneElement(item, setExtraPropsCategories(index));
    }), editable && fakeChildren && fakeChildren())));
  };
  CategoryGallery.defaultProps = {
    editable: false,
    fakeChildren: () => {},
    categories: [],
    action: {
      target: '',
      label: ''
    }
  };
  return CategoryGallery;
}();
var CategoryGallery$1 = CategoryGallery;
var BUTTON_DESIGN = {
  STANDARD: 'standard',
  LINK_TEXT: 'link-text'
};
var CategoryLabelImageHeader = function CategoryLabelImageHeader(_ref) {
  var _AndesButton, _div;
  var cta = _ref.cta,
    _ref$hasButtonAction = _ref.hasButtonAction,
    hasButtonAction = _ref$hasButtonAction === void 0 ? true : _ref$hasButtonAction,
    _ref$hasPriceCategory = _ref.hasPriceCategory,
    hasPriceCategory = _ref$hasPriceCategory === void 0 ? true : _ref$hasPriceCategory,
    _ref$hasTitleCategory = _ref.hasTitleCategory,
    hasTitleCategory = _ref$hasTitleCategory === void 0 ? true : _ref$hasTitleCategory,
    price = _ref.price,
    subtitle = _ref.subtitle,
    titleCategory = _ref.title,
    _ref$isPriceInvalid = _ref.isPriceInvalid,
    isPriceInvalid = _ref$isPriceInvalid === void 0 ? false : _ref$isPriceInvalid,
    buttonDesign = _ref.buttonDesign;
  var title = hasTitleCategory && /*#__PURE__*/_createRawReactElement("p", {
    className: "section-category-item__title font-secondary-text"
  }, void 0, titleCategory);
  var priceContainer = hasPriceCategory && !isPriceInvalid && /*#__PURE__*/_createRawReactElement("div", {
    className: "section-category-item__price-container"
  }, void 0, /*#__PURE__*/_createRawReactElement("p", {
    className: "section-category-item__subtitle font-secondary-text"
  }, void 0, subtitle), /*#__PURE__*/_createRawReactElement("span", {
    "aria-label": "category-price",
    className: "section-category-item__price font-secondary-text"
  }, void 0, price));
  var renderButton = function renderButton() {
    return _AndesButton || (_AndesButton = /*#__PURE__*/_createRawReactElement(Button, {
      hierarchy: "quiet",
      size: "small"
    }, void 0, cta));
  };
  var renderLink = function renderLink() {
    return _div || (_div = /*#__PURE__*/_createRawReactElement("div", {
      className: "section-category-item__foot-link"
    }, void 0, /*#__PURE__*/_createRawReactElement("span", {}, void 0, cta)));
  };
  var buttonContainer = hasButtonAction && /*#__PURE__*/_createRawReactElement("div", {
    className: "section-category-item__button-container"
  }, void 0, buttonDesign === BUTTON_DESIGN.STANDARD ? renderButton() : renderLink());
  return /*#__PURE__*/React.createElement(React.Fragment, null, title, priceContainer, buttonContainer);
};
var CategoryLabelImageHeader$1 = CategoryLabelImageHeader;
var CategoryLabelImage = function CategoryLabelImage(props) {
  var customStyles = props.customStyles,
    shopModel = props.shopModel,
    styles = props.styles,
    content = props.content,
    _props$i18n = props.i18n,
    i18n = _props$i18n === void 0 ? {
      gettext: function gettext(f) {
        return f;
      }
    } : _props$i18n,
    isMobile = props.isMobile,
    trackingId = props.trackingId;
  var _ref = (shopModel === null || shopModel === void 0 ? void 0 : shopModel.shop) || (shopModel === null || shopModel === void 0 ? void 0 : shopModel.storefront) || {},
    _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? '' : _ref$domain;
  var buttonDesign = customStyles.button_design;
  var behavior = content.behavior,
    titleCatgeory = content.label,
    linkCategory = content.link.url,
    _content$price_from = content.price_from,
    priceCategory = _content$price_from.whole,
    priceSymbol = _content$price_from.currency_symbol,
    showTitle = content.show_title_category,
    showPrice = content.show_base_price,
    showCta = content.show_category_button,
    cta = content.category_button_text;
  var addTrackUrl = function addTrackUrl(baseUrl) {
    var encodedPlaceholder = '%7Btracking_id%7D';
    var encodedTrackingId = encodeURIComponent(trackingId);
    return (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.replace(encodedPlaceholder, encodedTrackingId)) || baseUrl || '';
  };
  var trackedUrl = addTrackUrl(linkCategory);
  var urlImage = styles.background_image,
    isDefaultImage = styles.is_default_image;
  var hasTitleCategory = Boolean(showTitle && titleCatgeory);
  var hasPriceCategory = Boolean(showPrice && priceCategory);
  var hasButtonAction = Boolean(showCta && cta);
  var isPriceInvalid = priceCategory && priceCategory === '0';
  var behaviorClassName = Classnames('section-category-item__header', {
    'section-category-item__title--hidden': !hasTitleCategory,
    'section-category-item__price--hidden': !hasPriceCategory,
    'section-category-item__button--hidden': !hasButtonAction,
    'section-category-item__price--hidden-eshops': isPriceInvalid
  });
  var itemClass = Classnames('section-category-item', _defineProperty({}, "section-category-item--".concat(behavior), behavior));
  var priceEshops = hasPriceCategory ? "".concat(priceSymbol, " ").concat(priceCategory) : '';
  var eshopsInfo = {
    price: priceEshops,
    subtitle: i18n.gettext('Desde')
  };
  var imageContainerClass = Classnames('section-category-item__image-container', {
    'section-category-item__image-default': isDefaultImage
  });
  return /*#__PURE__*/_createRawReactElement(Action, {
    className: itemClass,
    target: trackedUrl,
    isSelf: true,
    domain: domain
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "section-category-item__container"
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: imageContainerClass
  }, void 0, /*#__PURE__*/_createRawReactElement(Image, {
    className: "section-category-item__image",
    src: urlImage,
    onload: "on",
    alt: titleCatgeory
  })), /*#__PURE__*/_createRawReactElement("div", {
    className: behaviorClassName
  }, void 0, /*#__PURE__*/_createRawReactElement(CategoryLabelImageHeader$1, {
    cta: cta,
    price: eshopsInfo.price,
    subtitle: eshopsInfo.subtitle,
    title: titleCatgeory,
    hasButtonAction: hasButtonAction,
    hasPriceCategory: hasPriceCategory,
    hasTitleCategory: hasTitleCategory,
    isPriceInvalid: isPriceInvalid,
    isMobile: isMobile,
    buttonDesign: buttonDesign
  }))));
};
var CategoryLabelImage$1 = CategoryLabelImage;
export { CategoryGallery$1 as CategoriesGallery, CategoryLabelImage$1 as CategoryLabelImage, CategoryLabelImageHeader$1 as CategoryLabelImageHeader };
